(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["community-comment-rotator"] && !Shopify.designMode) return;
  try {
    const rotatorStates = new WeakMap();

function initializeCommunityRotators(root = document) {
  const rotators = root.matches?.('[data-community-rotator]') ? [root] : [...root.querySelectorAll('[data-community-rotator]')];
  rotators.forEach((rotator) => {
    if (rotatorStates.has(rotator)) return;
    const comments = [...rotator.querySelectorAll('[data-community-comment]')];
    if (comments.length <= 2) return;

    const interval = Math.max(1000, Number(rotator.dataset.rotationInterval) || 2000);
    let activeStart = 0;
    let timer = null;
    let visible = typeof IntersectionObserver !== 'function';

    const stop = () => {
      if (timer !== null) window.clearInterval(timer);
      timer = null;
    };
    const start = () => {
      if (timer !== null || !visible || document.hidden) return;
      timer = window.setInterval(() => {
        activeStart = (activeStart + 2) % comments.length;
        const nextPair = new Set([activeStart, (activeStart + 1) % comments.length]);
        comments.forEach((comment, index) => {
          const shouldShow = nextPair.has(index);
          const shouldAnimate = shouldShow && comment.getAttribute('aria-hidden') === 'true';
          comment.classList.remove('is-entering');
          comment.setAttribute('aria-hidden', String(!shouldShow));
          if (shouldAnimate) {
            window.requestAnimationFrame(() => comment.classList.add('is-entering'));
            window.setTimeout(() => comment.classList.remove('is-entering'), 450);
          }
        });
      }, interval);
    };
    const onVisibilityChange = () => document.hidden ? stop() : start();
    const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver((entries) => {
      visible = Boolean(entries[entries.length - 1]?.isIntersecting);
      if (visible) start(); else stop();
    }, { threshold: 0.05 }) : null;

    document.addEventListener('visibilitychange', onVisibilityChange);
    observer?.observe(rotator);
    rotatorStates.set(rotator, { observer, onVisibilityChange, stop });
    start();
  });
}

function disposeCommunityRotators(root) {
  const rotators = root.matches?.('[data-community-rotator]') ? [root] : [...root.querySelectorAll('[data-community-rotator]')];
  rotators.forEach((rotator) => {
    const state = rotatorStates.get(rotator);
    if (!state) return;
    state.stop();
    state.observer?.disconnect();
    document.removeEventListener('visibilitychange', state.onVisibilityChange);
    rotatorStates.delete(rotator);
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeCommunityRotators(), { once: true });
else initializeCommunityRotators();
document.addEventListener('shopify:section:load', (event) => initializeCommunityRotators(event.target));
document.addEventListener('shopify:section:unload', (event) => disposeCommunityRotators(event.target));
  } catch(e) { console.error(e); }
})();

})();
